module.exports = __webpack_public_path__ + "static/media/sbtv_website_banner_30fps_0_72mbit.eea9041e.mp4";